







































import { Component, Prop, Vue } from "vue-property-decorator";

import * as def from "@/definitions";

import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";
import DropdownList from "@/commonComponents/dropdownList/dropdownList.vue";

import SearchGlass from "../resources/searchGlass.vue";
import ValueDown from "../resources/valueDown.vue";

const isElement = (x: any): x is HTMLInputElement =>
  x instanceof HTMLInputElement;

@Component({
  components: {
    ValueEdit,
    DropdownList,

    SearchGlass,
    ValueDown
  }
})
export default class TopController extends Vue {
    @Prop()
    private searchWord!: string;
    @Prop()
    private paperDirection!: number;

    canSubmit = false

    changeSearchProperty(value: any, propertyName: string) {
        this.$emit("changeSearchProperty", value, propertyName);
    }

    changeSearchType() {
        this.$emit("changeSearchType", "size");
    }

    resetSerachText(){
        this.changeSearchProperty("" , "searchWord");
        this.search()
    }

    search(enter : boolean = false) {
        if(enter){
            if(this.canSubmit){
                this.$emit("search");
            }
        }else{
            this.$emit("search");
        }
        this.canSubmit = false;   
    }

    putFocus() {
        if (!isElement(this.$refs.input)) return;
        this.$refs.input.focus();
    }

    //編集面の回転
    private isPaperDirectionDropdownActive = false;

    private get paperDirectionText() {
        var text = "";
        if (this.paperDirection == 0) {
            text = "回転しない";
        } else if (this.paperDirection == 1) {
            text = "90°回転";
        } else if (this.paperDirection == 2) {
            text = "180°回転";
        } else if (this.paperDirection == 3) {
            text = "270°回転";
        }
        return text;
    }

    private get paperDirectionDropdownItems() {
        var items = new Array();
        items.push({
            id: 0,
            label: "回転しない",
            isSelected: this.paperDirection == 0
        });
            items.push({
            id: 1,
            label: "90°回転",
            isSelected: this.paperDirection == 1
        });
        items.push({
            id: 2,
            label: "180°回転",
            isSelected: this.paperDirection == 2
        });
            items.push({
            id: 3,
            label: "270°回転",
            isSelected: this.paperDirection == 3
        });
        return items;
    }

    private onClickPaperDirection() {
        this.isPaperDirectionDropdownActive = true;
    }

    onSelectPaperDirection(paperDirection) {
        this.isPaperDirectionDropdownActive = false;
        this.$emit("changePaperDirection" , paperDirection)
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineStyle(){
        var style = {
            borderBottom : "solid 1px " + this.userConfigColor
        };
        return style;
    }
    private get userConfigColorStyle(){
        var style = {
            color : this.userConfigColor
        };
        return style;
    }
    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }
}
